import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { RackDTO } from './dto/racks.dto';
import { RacksService } from './racks.service';
import { AllRacksResponseModel, CommonResponse, RackDropDownDto,  RackDropDownResponseModel,  RackResponseModel, RacksForZoneId } from '@gtpl/shared-models/masters';
import { RackRequest } from './dto/racks.request';
import { ApiTags } from '@nestjs/swagger';
import { ZoneByIdDto } from './dto/zone-id-request-dto';
import { Rack } from './racks.entity';
import { RackIdRequest } from './dto/rackId.request';
import { PlantIdRequest } from '@gtpl/shared-models/warehouse-management';

@ApiTags('racks')
@Controller('racks')
export class RacksController {

    constructor(
        private rackService: RacksService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

    @Post('/createRack')
    async createRack(@Body() rackDto:RackDTO,isUpdate:boolean=false,@Req() request:Request): Promise<RackResponseModel> {
        try {
        return await this.rackService.createRack(rackDto,false,request);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(RackResponseModel, error);
        }
    }

    @Post('/getAllRacks')
    async getAllRacks(): Promise<AllRacksResponseModel> {
    try {
        return await this.rackService.getAllRacks();
        } catch (error) {
        return this.applicationExceptionHandler.returnException(AllRacksResponseModel, error);
        }
    }

    @Post('/getAllActiveRacks')
    async getAllActiveRacks(@Req() request: Request): Promise<AllRacksResponseModel> {
        try {
            return await this.rackService.getAllActiveRacks();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllRacksResponseModel, error)
        }
    }

    /**
     * Activate Or De-Activate Value Rack
     * @param getSingleRack RackResponseModel 
     * @returns Value Rack
     */
    @Post('/activateOrDeactivateRack')
    async activateOrDeactivateRack(@Body() rackReq: RackRequest): Promise<RackResponseModel> {
        try {
            return await this.rackService.activateOrDeactivateRack(rackReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(RackResponseModel, err);
        }
    }

    /**
     * creates or updates a value of Rack
     * @param RackDto Rack DTO
     * @returns RackResponse
     */
    @Post('/updateRack')
    async updateRack(@Body() rackDto:RackDTO,isUpdate:boolean=true,@Req() request:Request): Promise<RackResponseModel> {
        try {
            return await this.rackService.createRack(rackDto,true,request);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RackResponseModel, error);
        }
    }

    @Post('/getAllRackDropDown')
    async getAllRackDropDown(): Promise<RackDropDownResponseModel> {
        try {
            return await this.rackService.getAllRackDropDown();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RackDropDownResponseModel, error);
        }
    }

    @Post('/getRackById')
    async getRackById(@Body() rackreq: RackRequest): Promise<Rack> {
        try {
            return await this.rackService.getRackById(rackreq.rackId);
        } catch (err) {
            return err;
        }
    }

    @Post('/getRacksForZoneId')
    async getRacksForZoneId(@Body() zoneIdReq:ZoneByIdDto): Promise<RackDropDownResponseModel> {
        try {
            return await this.rackService.getRacksForZoneId(zoneIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RackDropDownResponseModel, error);
        }
    }

    @Post('/getRacksForZone')
    async getRacksForZone(@Body() zoneIdReq:ZoneByIdDto): Promise<RackDropDownResponseModel> {
        try {
            return await this.rackService.getRacksForZone(zoneIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RackDropDownResponseModel, error);
        }
    }

    @Post('/getRacksForRackId')
    async getRacksForRackId(@Body() rackIdRequest:RackIdRequest): Promise<RackDropDownDto> {
        try {
            return await this.rackService.getRacksForRackId(rackIdRequest);
        } catch (error) {
        //  return this.applicationExceptionHandler.returnException(RackDropDownDto, error);
        }
    }
    @Post('/getdummyRacksByZone')
    async getdummyRacksByZone(@Body() zoneId: RacksForZoneId): Promise<RackDropDownResponseModel> {
        try {
            return await this.rackService.getdummyRacksByZone(zoneId);
        } catch (error) {
        //  return this.applicationExceptionHandler.returnException(RackDropDownDto, error);
        }
    }
    @Post('/getAllRacksForPlant')
    async getAllRacksForPlant(@Body() plantId: PlantIdRequest): Promise<AllRacksResponseModel> {
        try {
            return await this.rackService.getAllRacksForPlant(plantId);
        } catch (error) {
        //  return this.applicationExceptionHandler.returnException(RackDropDownDto, error);
        }
    }

    @Post('/transferRack')
    async transferRack(@Body() rackDetails:any): Promise<CommonResponse> {
        try {
            return await this.rackService.transferRack(rackDetails);
        } catch (error) {
        //  return this.applicationExceptionHandler.returnException(RackDropDownDto, error);
        }
    }

}
